import { lazy, useMemo } from 'react'

import { useMe } from '@/providers'
import LoadableSuspense from '@components/Loadable/Loadable'

const Dashboard = LoadableSuspense(lazy(() => import('@views/Dashboard/Dashboard')))

export default function Home() {
	const me = useMe()

	const content = useMemo(() => {
		// Note: This useMemo is for future use
		// As we fill out how roles will work, we can use this to determine what to show
		if (me.isSuperAdmin) return <Dashboard />

		return <Dashboard />
	}, [me.isSuperAdmin])

	return content
}
